import { render } from "./MultiChannel.vue?vue&type=template&id=d35f6834"
import script from "./MultiChannel.vue?vue&type=script&lang=js"
export * from "./MultiChannel.vue?vue&type=script&lang=js"

import exportComponent from "/app/widget-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__